<template>
  <footer :class="$mq.phone ? 'mobile-footer': 'top20-footer'">
    <div v-if="isTop20Talent && $mq.phone" class="top-talent-footer columns">
      <div :class="{'is-2-columns': !userCurrencyPreference}" class="column is-flex corp-section-wrapper">
        <currency-selection-container
          v-if="userCurrencyPreference"
          :changeItemHandler="changeUserPreferences"
          :preselectedItem="userCurrencyPreference"
          :dropUpDirection="true"
        />
        <footer-item-copyright />
        <footer-item-website-record-number />
        <footer-item-language
          :isChinese="isChinese()"
          :setEnglishLanguage="setEnglishLanguage"
          :setChineseLanguage="setChineseLanguage"
        />
      </div>
      <div class="column v-align secondary-section-wrapper">
        <div class="column secondary-section is-flex">
          <footer-item-policy/>
          <footer-item-contact/>
          <footer-item-terms/>
        </div>
      </div>
    </div>
    <div v-else class="columns">
      <div class="column is-2 v-align corp-section-wrapper">
        <footer-item-copyright />
      </div>
      <div class="column is-2 v-align corp-section-wrapper">
        <footer-item-website-record-number />
      </div>

      <div class="column is-8 v-align secondary-section-wrapper">
        <div :class="{column: $mq.phone}" class="secondary-section is-flex">
          <footer-item-language
            :isChinese="isChinese()"
            :setEnglishLanguage="setEnglishLanguage"
            :setChineseLanguage="setChineseLanguage"
          />

          <currency-selection-container
            v-if="userCurrencyPreference"
            :changeItemHandler="changeUserPreferences"
            :preselectedItem="userCurrencyPreference"
            :dropUpDirection="true"
          />
          <footer-item-contact/>
          <footer-item-policy/>
          <footer-item-terms/>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>

import {isEmpty} from 'lodash';

import CurrencySelectionContainer from '../components/CurrencySelectionContainer';
import DropdownTooltip from '../components/DropdownTooltip';
import FooterItemContact from '../components/footer/FooterItemContact';
import FooterItemCopyright from '../components/footer/FooterItemCopyright';
import FooterItemLanguage from '../components/footer/FooterItemLanguage';
import FooterItemPolicy from '../components/footer/FooterItemPolicy';
import FooterItemTerms from '../components/footer/FooterItemTerms';
import FooterItemWebsiteRecordNumber from '../components/footer/FooterItemWebsiteRecordNumber';

export default {
  computed: {
    userCurrencyPreference() {
      return this.userDetailsState && this.userDetailsState.currency;
    },
    userDetailsState() {
      return this.$store.getters.userDetailsState;
    },
    isTop20Talent() {
      return this.$context.isTop20Talent;
    }
  },
  methods: {
    isChinese() {
      return this.$language.isChinese();
    },
    setChineseLanguage() {
      this.setLanguage(this.$language.cnLocale);
    },
    setEnglishLanguage() {
      this.setLanguage(this.$language.enLocale);
    },
    setLanguage(lang) {
      this.$language.set(lang);

      if (isEmpty(this.userDetailsState)) {
        window.location.reload();
      } else {
        this.$toast.open({
          message: this.$gettext('Language preferences updated'),
          type: 'is-success'
        });
        this.$store
          .dispatch('changeUserPreferencesAction', {value: {language: this.$language.getLanguageParam()}})
          .then(() => {
            window.location.reload();
          });
      }
    },
    changeUserPreferences(currency) {
      this.$toast.open({
        message: this.$gettext('Currency preferences updated'),
        type: 'is-success'
      });
      return this.$store.dispatch('changeUserPreferencesAction', {value: {currency}}).then(response => {
        window.location.reload();
      });
    }
  },
  components: {
    FooterItemContact,
    FooterItemTerms,
    CurrencySelectionContainer,
    FooterItemWebsiteRecordNumber,
    FooterItemLanguage,
    FooterItemPolicy,
    FooterItemCopyright,
    DropdownTooltip
  }
};
</script>

<style lang="scss" scoped>
@import '~VariablesStyles';

.secondary-section-wrapper {
  z-index: 1;
  padding: 0;
  justify-content: flex-end;

  .secondary-section {
    margin-bottom: 10px;
    padding-left: 0;
    padding-right: 0;
  }
}

footer {
  .corp-section-wrapper {
    z-index: 1;
  }

  &:not(.mobile-footer) {
    width: 100%;
    padding: 0 20px;

    .is-flex {
      justify-content: flex-end;
    }
  }

  /deep/ svg {
    margin-right: 5px;
  }
}

@media screen and (min-width: $tablet) {
  .top20-footer {
    margin-top: -47px;
  }
}

@media screen and (max-width: $tablet) {
  footer {
    &.mobile-footer {
      padding-left: 20px;
      padding-right: 20px;
      margin-bottom: 20px;

      & > div {
        position: relative;
        z-index: 0;
      }

      .top-talent-footer .is-flex {
        justify-content: space-around;
      }

      &:not(.top-talent-footer) .secondary-section {
        justify-content: space-between;
      }

      .corp-section-wrapper {
        justify-content: center;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  footer {
    .corp-section-wrapper {
      padding: 0;
    }
  }
}

@media screen and (max-width: 414px) {
  /deep/ a {
    font-size: 12px;
  }
}

@media screen and (max-width: $tablet) {
  &.mobile-footer .top-talent-footer > div.is-2-columns:first-child {
    /deep/ .block-copyright {
      display: flex;
      justify-content: flex-end;
      flex: 1.4;
      padding-right: 30px;
    }

    div:not(.block-copyright) {
      flex: 1;
      display: flex;
    }
  }
}
</style>
